import { motion } from 'framer-motion';

interface PageHeaderAction {
  label: string;
  icon?: string;
  onClick: () => void;
  loading?: boolean;
  variant?: 'default' | 'primary';
}

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: PageHeaderAction;
}

export default function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      className="flex items-center justify-between mb-8"
    >
      <div>
        <h2 className="text-white text-xl font-semibold leading-tight font-display">
          {title}
        </h2>
        {subtitle && (
          <p className="text-white/35 text-sm mt-1">{subtitle}</p>
        )}
      </div>

      {action && (
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={action.onClick}
          disabled={action.loading}
          className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg transition-all cursor-pointer whitespace-nowrap disabled:opacity-50 ${
            action.variant === 'primary'
              ? 'page-action-primary'
              : 'page-action-ghost'
          }`}
        >
          {action.icon && (
            <div className="w-4 h-4 flex items-center justify-center">
              <i className={`${action.icon} text-sm ${action.loading ? 'animate-spin' : ''}`} />
            </div>
          )}
          {action.label}
        </motion.button>
      )}
    </motion.div>
  );
}
